'use strict';

angular.module('app').directive('laNav', function() {
    return {
        restrict: 'A',
        link: function(scope, elem) {
            var $elem = $(elem),
                links = $elem.children('a'),
                elements = [];

            _.each(links, function (v) {
                elements.push(v.hash);
            });

            $(document).on('scroll', function() {
                var _this = $(this);

                _.each(elements, function (v) {
                    var el = $(v);

                    if (el.length && (_this.scrollTop() + 65 >= el.offset().top && _this.scrollTop() + 65 <= el.offset().top + el.outerHeight() )) {
                        $elem.find('[href="' + v +'"]').addClass('active');
                    } else  {
                        $elem.find('[href="' + v +'"]').removeClass('active');
                    }
                });
            });

            scope.$on("$routeChangeStart", function () {
                $(document).off('scroll');
            });
        }
    };
});